import uniq from "lodash/uniq";
import { shouldSkipImageProcessing, createImageUrl } from "@grandvisionhq/utils";
import { Breakpoints } from "../../MediaQuery/MediaQuery/helpers.js";
const MAX_IMAGE_WIDTH = 2880;
const createImgUrl = (url, params) => {
  if (shouldSkipImageProcessing(url)) {
    return url;
  }
  return createImageUrl(url, { ...params });
};
const clampWidth = (width) => {
  return width > MAX_IMAGE_WIDTH ? MAX_IMAGE_WIDTH : width;
};
const createCssImageSetStyle = (url, width, imageParams, opts) => {
  const clampedWidth = clampWidth(width);
  const allPds = opts?.extraPixelDensities && opts.extraPixelDensities.length > 0 ? [1, ...opts.extraPixelDensities].sort() : [1];
  const imageSizeValues = uniq(allPds.map((pd) => clampWidth(clampedWidth * pd)));
  const allImageUrls = imageSizeValues.map(
    (imageWidth, index) => `url("${createImageUrl(url, {
      ...imageParams,
      width: imageWidth
    })}") ${index + 1}x`
  ).join(", ");
  return {
    backgroundImage: `image-set(${allImageUrls})`,
    ...opts?.style
  };
};
const createImageSrcSetItem = (url, width, imageParams) => {
  if (shouldSkipImageProcessing(url)) {
    return url;
  }
  const clampedWidth = clampWidth(width);
  return `${createImageUrl(url, {
    ...imageParams,
    width: clampedWidth
  })} ${clampedWidth}w`;
};
const createImageSrcSet = (url, imageSizes, imageParams, opts) => {
  if (shouldSkipImageProcessing(url)) {
    return url;
  }
  const allPds = opts?.extraPixelDensities && opts.extraPixelDensities.length > 0 ? [1, ...opts.extraPixelDensities].sort() : [1];
  const originalImageSizeValues = Object.values(imageSizes).filter(Boolean);
  const imageSizeValues = uniq(
    allPds.map((pd) => originalImageSizeValues.map((val) => clampWidth(val * pd))).flat()
  ).sort((a, b) => a - b);
  return imageSizeValues.map((size) => createImageSrcSetItem(url, size, imageParams)).join(", ");
};
const getSize = (pixelDensity, maxWidth, imageSize) => {
  const highPdCondition = pixelDensity > 1 ? `(min-resolution: ${pixelDensity}dppx)` : "";
  const maxWidthCondition = maxWidth ? `(max-width: ${maxWidth}px)` : "";
  const union = highPdCondition && maxWidthCondition ? " and " : "";
  return `${highPdCondition}${union}${maxWidthCondition} ${clampWidth(
    pixelDensity * imageSize
  )}px`.trim();
};
const createImageSizes = (imageSizes, url, opts) => {
  if (shouldSkipImageProcessing(url)) {
    return void 0;
  }
  const allPds = opts?.extraPixelDensities && opts.extraPixelDensities.length > 0 ? [...opts.extraPixelDensities.sort().reverse(), 1] : [1];
  let result = Object.entries(Breakpoints).sort(([, a], [, b]) => a - b).map(([bpKey, bpValue]) => {
    const imageSize = imageSizes[bpKey];
    if (!imageSize) {
      return void 0;
    }
    return allPds.map((pd) => getSize(pd, bpValue, imageSize)).join(", ");
  }).filter(Boolean).join(", ");
  const maxImageSize = imageSizes.MAX;
  if (maxImageSize) {
    const desktopSize = allPds.map((pd) => getSize(pd, void 0, maxImageSize)).join(", ");
    result = `${result}${result ? ", " : ""}${desktopSize}`;
  }
  return result;
};
export {
  createCssImageSetStyle,
  createImageSizes,
  createImageSrcSet,
  createImageSrcSetItem,
  createImgUrl
};
//# sourceMappingURL=responsive-image-helpers.js.map
